
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { NavItem as NavItemType } from "./navTypes";

interface NavItemProps {
  item: NavItemType;
}

const NavItem: React.FC<NavItemProps> = ({ item }) => {
  const location = useLocation();
  const isActive = location.pathname === item.href;

  return (
    <Link
      to={item.href}
      className={cn(
        "flex items-center gap-3 px-3 py-2 rounded-md hover:bg-accent transition-colors",
        isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground"
      )}
    >
      <item.icon className="h-5 w-5 shrink-0" />
      <div>
        <div 
          className={cn(
            "text-sm font-medium", 
            isActive ? "text-primary" : ""
          )}
        >
          {item.title}
        </div>
        <p className="text-xs hidden lg:block text-muted-foreground">
          {item.description}
        </p>
      </div>
    </Link>
  );
};

export default NavItem;
